import React from "react";
import styled from "@emotion/styled";
import { Helmet } from "react-helmet-async";

import {
  Avatar,
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Dialog,
  DialogContent,
  DialogTitle,
  Paper,
  TextField,
  Typography,
  View,
} from "@mui/material";

import { ReactComponent as Logo } from "../../vendor/logo.svg";
import SignInComponent from "../../components/auth/SignIn";
import useAuth from "../../hooks/useAuth";
import { Box, Container } from "@mui/system";
import QrCode2Icon from "@mui/icons-material/QrCode2";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import QRCode from "react-qr-code";
import appStoreIcon from "../../assets/appstoreicon.png";
import playStoreIcon from "../../assets/playstoreicon.png";
import { Link } from "react-router-dom";

const Wrapper = styled(Paper)`
padding: ${(props) => props.theme.spacing(6)};

  ${(props) => props.theme.breakpoints.up("md")} {
  padding: ${(props) => props.theme.spacing(8)};
  padding - top: ${(props) => props.theme.spacing(0)};
}
`;

const BigAvatar = styled(Avatar)`
width: 92px;
height: 92px;
text - align: center;
margin: 0 auto ${(props) => props.theme.spacing(5)};
`;

function SignIn() {
  const { configuration } = useAuth();

  const [openOneClickNotification, setOpenOneClickNotification] =
    React.useState(false);

  const closeModalNotification = () => {
    setOpenOneClickNotification(false);
  };

  const copyToClipBoard = async (value) => {
    await navigator.clipboard.writeText(value);

    alert("Código copiado, agora é só colar no App ;)");
  };

  /*
   * Link para acesso à 2ª via.
   * Mantém o domínio configurado para cada cliente.
   */
  const secondCopyLink = "/consultar/faturas";

  return (
    <React.Fragment>
      <Container sx={{ marginTop: window.isNativeApp ? 10 : 20 }}>
        {configuration &&
          (configuration.brandmark ? (
            <center>
              <img
                src={configuration.brandmark}
                width="250"
                height="150"
                alt={configuration.website_name}
              />
            </center>
          ) : (
            <center>
              <Typography
                component="h1"
                variant="h4"
                align="center"
                gutterBottom
              >
                {configuration.website_name}
              </Typography>
            </center>
          ))}

        <Wrapper>
          {configuration && <Helmet title={"Login"} />}

          <SignInComponent />

          <br />

          <span>
            Esqueceu a senha?{" "}
            <a href="/reset-password">Clique aqui</a>
          </span>

          {/* Botão / chamada para 2ª via */}
          <Box
            sx={{
              marginTop: 3,
              width: "100%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Button
              variant="contained"
              fullWidth
              startIcon={<ReceiptLongIcon />}
              href={secondCopyLink}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                maxWidth: 350,
                minHeight: 35,
                borderRadius: 3,
                textTransform: "none",
                fontSize: "16px",
                fontWeight: 700,
                boxShadow: "0 5px 15px rgba(0,0,0,0.15)",
                background:
                  "linear-gradient(135deg, #1976d2 0%, #42a5f5 100%)",
                transition: "all 0.2s ease-in-out",

                "&:hover": {
                  background:
                    "linear-gradient(135deg, #1565c0 0%, #1e88e5 100%)",
                  transform: "translateY(-2px)",
                  boxShadow: "0 8px 20px rgba(0,0,0,0.22)",
                },

                "&:active": {
                  transform: "translateY(0)",
                },
              }}
            >
              Acessar 2ª via da fatura
            </Button>
          </Box>

          <Typography
            variant="caption"
            align="center"
            display="block"
            sx={{
              marginTop: 1,
              color: "text.secondary",
            }}
          >
            Consulte, baixe ou copie o código de pagamento da sua fatura.
          </Typography>
        </Wrapper>
      </Container>

      {configuration &&
        !window.isNativeApp &&
        configuration.allow_app && (
          <Card sx={{ maxWidth: 190, border: 1 }}>
            <CardContent>
              <Typography gutterBottom variant="h5" component="div">
                Baixe o nosso App
              </Typography>

              <small>Aponte a camera no qrcode</small>
              <p></p>

              <center>
                <QRCode
                  size={100}
                  sx={{ fontSize: 100 }}
                  value={
                    "https://api-allstore.cachebank.com.br/downloadapp?configuration_id=" +
                    configuration.id
                  }
                />
              </center>
            </CardContent>

            <center>
              <Typography gutterBottom component="div">
                Já baixou? Abra o App
                <br />
                E leia o código novamente.
              </Typography>
            </center>
          </Card>
        )}

      {configuration.domain &&
        window.isNativeApp &&
        !window.isApp &&
        configuration.allow_app && (
          <Card sx={{ border: 1, flex: 1 }}>
            <CardContent>
              <center>
                <Typography gutterBottom variant="h5" component="div">
                  Baixe o nosso App
                </Typography>

                <a
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setOpenOneClickNotification(true);
                  }}
                >
                  {window.osSystem == "IOS" && (
                    <img
                      src={appStoreIcon}
                      style={{ height: "80px" }}
                      alt="App Store"
                    />
                  )}

                  {window.osSystem == "Android" && (
                    <img
                      src={playStoreIcon}
                      style={{ height: "80px" }}
                      alt="Google Play"
                    />
                  )}
                </a>
              </center>
            </CardContent>
          </Card>
        )}

      <Dialog
        open={openOneClickNotification}
        keepMounted
        onClose={closeModalNotification}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle textAlign={"center"}>
          {"Baixe o nosso App"}
        </DialogTitle>

        <DialogContent>
          <hr />

          <p>
            <strong>1º Passo</strong>
          </p>

          <p>
            Baixe o App{" "}
            <a href="">
              <strong>Minha Faturas</strong>
            </a>{" "}
            da loja, <a href="">clicando aqui</a>
          </p>

          <p></p>

          <hr />

          <p>
            <strong>2º Passo</strong>
          </p>

          <p>
            Copie o código abaixo e cole no App{" "}
            <strong>Minhas Faturas</strong>
          </p>

          <p>
            <TextField
              id="fulldomainId"
              onClick={(e) =>
                copyToClipBoard(
                  configuration.domain &&
                  configuration.domain["fulldomain"]
                )
              }
              disabled={false}
              fullWidth
              value={
                configuration.domain &&
                configuration.domain["fulldomain"]
              }
            />
          </p>

          <p></p>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}

export default SignIn;
